import { Trans, useTranslation } from "react-i18next";
import AppBar from "@/react/Webshop/Mobile/Components/AppBar";
import MobilePage, { PageHeader } from "@/react/Webshop/Components/MobilePage";
import React, { useState } from "react";
import Container from "@mui/material/Container";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import makeStyles from "@mui/styles/makeStyles";
import Button from "@/react/components/Common/Button";
import Box from "@mui/material/Box";
import Popup, { PopupActions, PopupButton, PopupContent, PopupHeading, } from "@/react/components/Common/Popup";
import { useAPI } from "@/react/lib/common";
const useStyles = makeStyles({
    root: {},
});
const DeleteAccountPage = () => {
    const classes = useStyles();
    const { t } = useTranslation();
    const [showDeleteWarning, setShowDeleteWarning] = useState(false);
    const [data, loading] = useAPI("/sections/my-account/ajax/get_account_data.php");
    if (loading) {
        return React.createElement("div", null, "Loading");
    }
    const { dataLifeSpan } = data;
    return (React.createElement(MobilePage, { requireUser: true },
        React.createElement(AppBar, null),
        React.createElement(PageHeader, null,
            React.createElement(Trans, null, "Delete my account")),
        React.createElement(Container, { className: classes.root, maxWidth: "sm" },
            React.createElement(Card, null,
                React.createElement(CardContent, null,
                    React.createElement("p", null, t("If you choose to delete your account your account will be instantly quarantined, and the account will be permanently deleted after %d days.", {
                        postProcess: "sprintf",
                        sprintf: [dataLifeSpan.deletedUserQuarantineDays],
                    })),
                    React.createElement("p", null,
                        React.createElement(Trans, null, "Deleting your account will delete your user and your connection to any picture sets connected to your account including your contact information from our servers.")),
                    React.createElement("p", null,
                        React.createElement(Trans, null, "While your account is in quarantine waiting for deletion you have the opportunity to reactivate your account by logging in again. If you do so your account will be completely restored.")),
                    React.createElement(Box, { display: "flex", justifyContent: "center" },
                        React.createElement(Button, { type: "button", onClick: () => setShowDeleteWarning(true) },
                            React.createElement(Trans, null, "Delete my account"))),
                    showDeleteWarning && (React.createElement(Popup, { onClose: () => setShowDeleteWarning(false) },
                        React.createElement(PopupHeading, null,
                            React.createElement(Trans, null, "Delete your account?")),
                        React.createElement(PopupContent, null,
                            React.createElement(Trans, null, "Are you sure you want to delete your account?")),
                        React.createElement(PopupActions, null,
                            React.createElement(PopupButton, { secondary: true, onClick: () => setShowDeleteWarning(false) },
                                React.createElement(Trans, null, "Cancel")),
                            React.createElement(PopupButton, { href: "/sections/prophoto/ajax/do_delete_account.php" },
                                React.createElement(Trans, null, "Yes, I want to delete the account"))))))))));
};
export default DeleteAccountPage;
